import { render, staticRenderFns } from "./rechargeCfg.vue?vue&type=template&id=f1125f8e&scoped=true&"
import script from "./rechargeCfg.vue?vue&type=script&lang=js&"
export * from "./rechargeCfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1125f8e",
  null
  
)

export default component.exports